import React from "react";
import {
    Box, Chip, LinearProgress, List, ListItem, ListItemIcon, ListItemText, Paper, Typography
} from "@mui/material";
import CheckCircleIcon from '@mui/icons-material/CheckCircle';
import CancelIcon from '@mui/icons-material/Cancel';

interface Props {
    documentTypes: iDocumentType[];
    documents: iPersonDocument[];
}

const DocumentChecklist = (props: Props) => {
    const { documentTypes, documents } = props;

    const requiredTypes = documentTypes.filter((dt) => dt.required && dt.active);
    if (requiredTypes.length === 0) return null;

    const uploadedTypeIds = documents.map((d) => d.documentTypeId);
    const completedCount = requiredTypes.filter((dt) => uploadedTypeIds.includes(dt.id)).length;
    const totalCount = requiredTypes.length;
    const percentage = totalCount > 0 ? Math.round((completedCount / totalCount) * 100) : 0;

    return (
        <Paper variant="outlined" sx={{ p: 2, mb: 2 }}>
            <Box sx={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', mb: 1 }}>
                <Typography variant="subtitle2" fontWeight="bold">
                    Checklist de Documentos Obrigatórios
                </Typography>
                <Chip
                    label={`${completedCount} de ${totalCount} — ${percentage}%`}
                    color={percentage === 100 ? 'success' : percentage >= 50 ? 'warning' : 'error'}
                    size="small"
                />
            </Box>
            <LinearProgress
                variant="determinate"
                value={percentage}
                color={percentage === 100 ? 'success' : percentage >= 50 ? 'warning' : 'error'}
                sx={{ mb: 1, height: 6, borderRadius: 3 }}
            />
            <List dense disablePadding>
                {requiredTypes.map((dt) => {
                    const isUploaded = uploadedTypeIds.includes(dt.id);
                    return (
                        <ListItem key={dt.id} disablePadding sx={{ py: 0.25 }}>
                            <ListItemIcon sx={{ minWidth: 28 }}>
                                {isUploaded
                                    ? <CheckCircleIcon fontSize="small" color="success" />
                                    : <CancelIcon fontSize="small" color="error" />
                                }
                            </ListItemIcon>
                            <ListItemText
                                primary={dt.name}
                                primaryTypographyProps={{
                                    variant: 'body2',
                                    color: isUploaded ? 'text.primary' : 'error'
                                }}
                            />
                        </ListItem>
                    );
                })}
            </List>
        </Paper>
    );
};

export default DocumentChecklist;
